import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import scriptjs from 'scriptjs';

import { FormLayoutFieldContainer } from '@fluid/layouts';

const useHookWithRefCallback = (promotionJSIncludes, promotionsVersion) => {
    const ref = useRef();
    const setRef = useCallback((nodeParam) => {
        const node = nodeParam;

        if (node && !node.promoLoaded) {
            node.promoLoaded = true;
            const callback = () => {
                const scripts = node.getElementsByTagName('script');
                const head = document.getElementsByTagName('head')[0];

                if (scripts && head) {
                    Array.from(scripts).forEach((script) => {
                        const html = script.innerHTML;

                        try {
                            const newScript = document.createElement('script');
                            newScript.type = 'text/javascript';
                            newScript.appendChild(
                                document.createTextNode(html),
                            );
                            head.insertBefore(newScript, head.firstChild);
                            head.removeChild(newScript);
                        } catch (e) {
                            console.log(e);
                        }
                    });
                }
            };

            if (promotionJSIncludes && promotionJSIncludes.length) {
                scriptjs(
                    promotionJSIncludes.map((path) => {
                        return `${path}?v=${promotionsVersion || ''}`;
                    }),
                    callback,
                );
            } else {
                callback();
            }
        }

        ref.current = node;
    }, []);

    return [setRef];
};

const LoginPromotions = (props) => {
    const { contextCls, legacyLoginConfig } = props;
    const {
        messagingServiceResp: promotionsHTML,
        promotionJSIncludes,
        promotionsVersion,
    } = legacyLoginConfig ?? {};

    const [ref] = useHookWithRefCallback(
        promotionJSIncludes,
        promotionsVersion,
    );

    if (!promotionsHTML) {
        return false;
    }

    return (
        <FormLayoutFieldContainer contextCls={contextCls}>
            <div
                ref={ref}
                dangerouslySetInnerHTML={{ __html: promotionsHTML }}
            />
        </FormLayoutFieldContainer>
    );
};

LoginPromotions.defaultProps = {};

LoginPromotions.propTypes = {
    contextCls: PropTypes.string,
    legacyLoginConfig: PropTypes.object,
};

export default LoginPromotions;
